import React, { useState } from 'react';
import downArrowIcon from '../../../assets/icons/down-arrow.png';
import Tooltip from "@mui/material/Tooltip";
import FeatureLayerWidget from './FeatureLayerWidget';
import biomassIcon from '../../../assets/icons/layers-icons/biomass.png';
import coalIcon from '../../../assets/icons/layers-icons/coal.png';
import cogenerationIcon from '../../../assets/icons/layers-icons/Cogeneration.png';
import gasIcon from '../../../assets/icons/layers-icons/gas.png';
import geothermalIcon from '../../../assets/icons/layers-icons/Geothermal.png';
import hydroIcon from '../../../assets/icons/layers-icons/hydro.png';
import nuclearIcon from '../../../assets/icons/layers-icons/nuclear.png';
import oilIcon from '../../../assets/icons/layers-icons/oil.png';
import petrocoke from '../../../assets/icons/layers-icons/Petroleum-coke.png';
import solarIcon from '../../../assets/icons/layers-icons/solar.png';
import storageIcon from '../../../assets/icons/layers-icons/storage.png';
import waste from '../../../assets/icons/layers-icons/waste.png';
import wavetidalIcon from '../../../assets/icons/layers-icons/wave-and-tidal.png';
import windIcon from '../../../assets/icons/layers-icons/wind.png';
import powerPlantIcon from '../../../assets/icons/power-plant-icon-black.png';


export default function PowerPlants(props) {
    const {
        map,
    } = props;

    const [expanded, setExpanded] = useState(false);
    const [activeLayers, setActiveLayers] = useState([]);

    const powerPlantLayers = [
        {
            name: 'Solar Stations',
            icon: solarIcon,
            id: 'Layer-powerplants-Solar-symbol',
        },
        {
            name: 'Biomass Stations',
            icon: biomassIcon,
            id: 'Layer-powerplants-Biomass-symbol',
        },
        {
            name: 'Coal Stations',
            icon: coalIcon,
            id: 'Layer-powerplants-Coal-symbol',
        },
        {
            name: 'Cogeneration Stations',
            icon: cogenerationIcon,
            id: 'Layer-powerplants-Cogeneration-symbol',
        },
        {
            name: 'Gas Stations',
            icon: gasIcon,
            id: 'Layer-powerplants-Gas-symbol',
        },
        {
            name: 'Geothermal Stations',
            icon: geothermalIcon,
            id: 'Layer-powerplants-Geothermal-symbol',
        },
        {
            name: 'Hydro Stations',
            icon: hydroIcon,
            id: 'Layer-powerplants-Hydro-symbol',
        },
        {
            name: 'Nuclear Stations',
            icon: nuclearIcon,
            id: 'Layer-powerplants-Nuclear-symbol',
        },
        {
            name: 'Oil Stations',
            icon: oilIcon,
            id: 'Layer-powerplants-Oil-symbol',
        },
        {
            name: 'Petroleum Coke Stations',
            icon: petrocoke,
            id: 'Layer-powerplants-Petcoke-symbol',
        },
        {
            name: 'Storage Stations',
            icon: storageIcon,
            id: 'Layer-powerplants-Storage-symbol',
        },
        {
            name: 'Waste Stations',
            icon: waste,
            id: 'Layer-powerplants-Waste-symbol',
        },
        {
            name: 'Wave and Tidal Stations',
            icon: wavetidalIcon,
            id: 'Layer-powerplants-Wave and Tidal-symbol',
        },
        {
            name: 'Wind Stations',
            icon: windIcon,
            id: 'Layer-powerplants-Wind-symbol',
        },
        {
            name: 'Other',
            icon: powerPlantIcon,
            id: 'Layer-powerplants-Other-symbol',
        },
        {
            name: 'Unknown',
            icon: powerPlantIcon,
            id: 'Layer-powerplants-undefined-symbol',
        }
    ];

    return (
       <div className='weather-widgets-feature-layer-widget-expandable'>
            <Tooltip
                title='Displays the locations of power plants, highlighting critical energy infrastructure for monitoring and wildfire prevention.'
                arrow
                placement='left'
                
            >
                <div 
                    className={activeLayers.length > 0 ? 'weather-widgets-widget-active' : 'weather-widgets-widget' }
                    style={{  zIndex: 22 }}
                    onClick={() => {
                        const layers = map.current.getStyle().layers;
                        const powerPlantsLayers = layers.filter((l) => l.id.includes('powerplants'));
                    
                        const allPowerPlantsPlotted = powerPlantsLayers.length === 16;
                    
                        if (allPowerPlantsPlotted) {
                            setExpanded((prevState) => !prevState);
                        } else {
                            console.log('Power plant layers are still loading. Please wait.');
                        }
                    }}
                      
                >
                    <div className={activeLayers.length > 0 ? 'weather-widgets-widget-active-title' : 'weather-widgets-widget-title'}> 
                        <img 
                            src={downArrowIcon} 
                            className='weather-widgets-widget-arrow'
                            style={{
                                transition: 'transform 0.5s ease',
                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            }}
                        />
                        Power Plants
                    </div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={powerPlantIcon} 
                            className='weather-widgets-widget-img'
                        />
                    </div>
                </div>
            </Tooltip>
            {expanded &&
            <div 
                className='weather-widgets-feature-layer-widget-expandable-expanded'
                style={{ zIndex: 21 }}
                >
                {powerPlantLayers.map((layer) => {
                   return (
                        <FeatureLayerWidget 
                            layer={layer}
                            map={map}
                            activeLayers={activeLayers}
                            setActiveLayers={setActiveLayers}
                        />
                   )
                })}
            </div>
            }
       </div>
    )
}
